import React from 'react';

const MotovehiculoContext = React.createContext({
    marcas: null,
    anios: null,
    versiones: null,
    vehicleDetails: null,
    updateVersions: null,
    handleRecotizarInitialValues: null,
    isLoadingVersions: null,
    versionsError: null
});

export default MotovehiculoContext;